<template>
  <div class="content">
    <h1>你好，这个是忘记</h1>
  </div>
</template>

<script>
export default {
  title: '忘记',
  data () {
    return {
      data: '忘记'
    }
  }
}
</script>

<style lang="scss" scoped>
  .content {
    height: 100%;
    width: 100%;
  }
</style>
